import {
  EmailTemplate,
  EmailTemplateComponent,
  EmailTemplateComponentType,
  EmailTemplateTag,
  EmailTemplateTagType,
  EmailTemplateType,
  EmailTemplateVersion,
  IEmailTemplateResponse,
} from '../models/email-templates.models';
import { IOutreachTemplate } from '../models/outreach-templates.models';

export const baseOutreachTemplateMock: IOutreachTemplate = {
  title: 'title1',
  description: 'description1',
  language: 'en',
  suggested: false,
  favorite: false,
  subject: 'subject1',
  preheader: 'preheader1',
  content: 'bodyContent',
  templateId: 'templateId1',
  versionId: 'versionId1',
  active: true,
  createdBy: 'createdBy',
  lastUpdatedBy: 'updatedBy',
  dateCreated: 123,
  lastUpdated: 1234,
  tags: ['1'],
};

export const baseEmailTemplateMock: EmailTemplate = {
  email_template_id: 'templateId1',
  active_email_template_version_id: 'versionId1',
  type: EmailTemplateType.SolicitationOutreach,
  name: 'title1',
  description: 'description1',
  suggested: false,
  language: 'en',
  created_at: '1970-01-01T00:02:03.000Z',
  created_by: 'createdBy',
  updated_at: '1970-01-01T00:20:34.000Z',
  updated_by: 'updatedBy',
};

export const baseEmailTemplateVersionMock: EmailTemplateVersion = {
  email_template_version_id: 'versionId1',
  email_template_id: 'templateId1',
  active_email_template_component_history_id: 'componentHistoryId1',
  name: 'name1',
  created_at: '1970-01-01T00:02:03.000Z',
  created_by: 'createdBy',
  updated_at: '1970-01-01T00:20:34.000Z',
  updated_by: 'updatedBy',
};

export const emailTemplateSubjectComponentMock: EmailTemplateComponent = {
  email_template_component_id: 'componentId1',
  email_template_component_history_id: 'componentHistoryId1',
  email_template_version_id: 'versionId1',
  type: EmailTemplateComponentType.Subject,
  value: 'subject1',
  order: null,
  created_at: '1970-01-01T00:02:03.000Z',
  created_by: 'createdBy',
};

export const emailTemplatePreheaderComponentMock: EmailTemplateComponent = {
  email_template_component_id: 'componentId2',
  email_template_component_history_id: 'componentHistoryId1',
  email_template_version_id: 'versionId1',
  type: EmailTemplateComponentType.Preheader,
  value: 'preheader1',
  order: null,
  created_at: '1970-01-01T00:02:03.000Z',
  created_by: 'createdBy',
};

export const emailTemplateBodyComponentMock: EmailTemplateComponent = {
  email_template_component_id: 'componentId3',
  email_template_component_history_id: 'componentHistoryId1',
  email_template_version_id: 'versionId1',
  type: EmailTemplateComponentType.PlainText,
  value: 'bodyContent',
  order: 1,
  created_at: '1970-01-01T00:02:03.000Z',
  created_by: 'createdBy',
};

export const baseEmailTemplateResponseMock: IEmailTemplateResponse = {
  ...baseEmailTemplateMock,
  tags: baseOutreachTemplateMock.tags,
  favorite: false,
  versions: [
    {
      ...baseEmailTemplateVersionMock,
      components: [
        emailTemplateSubjectComponentMock,
        emailTemplatePreheaderComponentMock,
        emailTemplateBodyComponentMock,
      ],
    },
  ],
};

export const emailTemplateTagMock: EmailTemplateTag = {
  email_template_tag_id: 'email_template_tag_id',
  type: EmailTemplateTagType.TargetProfiles,
  name: 'name',
  created_at: '2025-10-01T00:00:00.000Z',
  updated_at: '2025-10-01T00:00:00.000Z',
  created_by: 'created_by',
  updated_by: 'updated_by',
};
